const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// src/api/productApi.js
// Minimal wrapper for /buyer/get-products

const BASE_URL = API_BASE_URL;

// sortBy values accepted by /buyer/get-products
export const PRODUCT_SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "price_low_high", label: "Price: Low to High" },
  { value: "price_high_low", label: "Price: High to Low" },
  { value: "popularity", label: "Popularity" },
  // Hidden until ratings can only be given after a delivered order
  // { value: "rating", label: "Rating" },
];

function getAuthHeaders() {
  const token =
    sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  return token ? { token } : {};
}

export async function getProducts(filters = {}, page = 1, limit = 10) {
  const body = { filters, page, limit };

  const res = await fetch(`${BASE_URL}/buyer/get-products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify(body),
  });

  // return parsed JSON; caller will decide how to read result
  return res.json();
}
